/**
 * /admin/dsar — DSAR queue (route shell).
 * Screen impl in `./dsar-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/dsar')({
  component: lazyRouteComponent(() => import('./dsar-screen'), 'AdminDsar'),
});
